<template>
    <div>
      <van-cell is-link @click="showPopup">
        <div class="address-def">
          <p class="p1">{{ addressInfo.name }} {{ addressInfo.tel }}<span v-if="addressInfo.status == 1">默认</span></p>
          <p class="p2">{{ addressInfo.province }}{{ addressInfo.city }}{{ addressInfo.county }}{{ addressInfo.detail }}</p>
        </div>
      </van-cell>
      <van-popup
      v-model="show"
      closeable
      position="bottom"
      :style="{ height: '50%' }"
      >
        <van-address-list
          v-model="chosenAddressId"
          :list="address"
          default-tag-text="默认"
          @add="onAdd"
          @edit="onEdit"
          @select="clickItem"
        />
      </van-popup>

      <div class="goods-show">
        <div class="g-s-l">
          <img :src="goods.image[0].file.full_url" />
        </div>
        <div class="g-s-r">
          <h3>{{ goods.goods_name }}</h3>
          <div class="g-s-r-m"><span class="price">￥{{ goods.sell_price }}</span><span class="num">x{{ purchases }}</span></div>
        </div>
      </div>
      <div class="expressage">
        <div class="info">配送方式<span>快递运输</span></div>
        <div class="info">运费<span>不包邮</span></div>
        <van-field
          v-model="remark"
          rows="1"
          autosize
          label="留言"
          type="textarea"
          maxlength="80"
          placeholder="选填，有什么要求写在这里"
        />
      </div>
      <div class="goods-price">
        <div class="g-r-li">商品件数：<span>{{ purchases }}件</span></div>
        <div class="g-r-li">商品总价：<span>￥{{ sum_price }}</span></div>
      </div>

      <van-submit-bar :price="sum_price * 100" button-text="提交订单" @submit="onSubmit" />
      <Floating />
      <wxNoShare />
    </div>
</template>

<script>
  import { SubmitBar, AddressList, Popup, Cell } from 'vant';

  export default {
    components: {
      [SubmitBar.name]: SubmitBar,
      [AddressList.name]: AddressList,
      [Cell.name]: Cell,
      [Popup.name]: Popup,
    },
    name: 'payment',
    data() {
      return {
        show: false,
        chosenAddressId: 0,
        address: [],
        purchases: 1,
        goods: [],
        sum_price: 0.00,
        addressInfo: {
          name: '请填写收货地址',
          tel: '',
          province: '',
          city: '',
          county: '',
          detail: '',
          status: 0,
        },
        remark: ''
      };
    },
    created() {
      this.purchases = this.$route.query.purchases
      this.addressList()
      this.$api.get('goods/details', {id:this.$route.query.goods_id, grade_id:this.$store.state.grade_id}, r=>{
        this.goods = r.data
        this.sum_price = (this.goods.sell_price * this.purchases).toFixed(2)
      })
    },
    methods: {
      onSubmit() {
        if(this.addressInfo.province === '' || this.addressInfo.detail === ''){
          this.$toast('请填写收货地址')
          return
        }
        this.$api.post('orders/store', {goods_id:this.goods.id, purchases:this.purchases, remark:this.remark, addressInfo: this.addressInfo, hid:localStorage.getItem('hid')}, r=>{
          this.$router.push({name:'paymentPay', query:{id:r.data.id}})
        })
      },
      onAdd() {
        this.$router.push({name:'addressAddEdit', query:{type:1}});
      },
      onEdit(item, index) {
        this.$router.push({name:'addressAddEdit', query:{id:item.id}});
      },
      showPopup() {
        this.show = true
      },
      clickItem(item, index) {
        this.addressInfo.name = item.name
        this.addressInfo.tel = item.tel
        this.addressInfo.province = item.province
        this.addressInfo.city = item.city
        this.addressInfo.county = item.county
        this.addressInfo.detail = item.detail
        this.addressInfo.status = item.status
        this.show = false
      },
      addressList() {
        this.$api.get('address', null, r=>{
          this.address = r.data
          for(let i=0; i<r.data.length; i++){
            if(r.data[i].isDefault){
              this.chosenAddressId = r.data[i].id
              this.addressInfo.name = r.data[i].name
              this.addressInfo.tel = r.data[i].tel
              this.addressInfo.province = r.data[i].province
              this.addressInfo.city = r.data[i].city
              this.addressInfo.county = r.data[i].county
              this.addressInfo.detail = r.data[i].detail
              this.addressInfo.status = r.data[i].status
            }
          }
        })
      }
    }
  }
</script>

<style scoped>
  .van-submit-bar__text{
    text-align: left;
  }
  .address-def .p1{
    font-weight: bold;
    font-size: 15px;
  }
  .address-def .p1 span{
    background: #ee0a24;
    color:#ffffff;
    font-size: 12px;
    margin-left: 4px;
    border-radius: 10px;
    padding: 2px 7px;
  }
  .address-def .p2{
    font-size: 14px;
  }
  .address-def p{
    margin: 0;
  }
  .van-cell__right-icon{
    margin-top:25px;
  }
  .goods-show{
    background: #ffffff;
    margin-top:10px;
    overflow: hidden;
    padding:15px 15px 5px;
  }
  .goods-show .g-s-l{
    float: left;
    width: 30%;
  }
  .goods-show .g-s-l img{
    width: 100%;
  }
  .goods-show .g-s-r{
    float: right;
    width: 65%;
  }
  .goods-show .g-s-r h3 {
    margin: 0;
    font-size: 15px;
    height: 55px;
  }
  .goods-show .g-s-r .g-s-r-m{
    overflow: hidden;
  }
  .goods-show .g-s-r .g-s-r-m .price{
    float: left;
    color:#ee0a24;
  }
  .goods-show .g-s-r .g-s-r-m .num{
    float: right;
    font-size: 14px;
    margin-top: 5px;
  }
  .expressage{
    background: #ffffff;
    overflow: hidden;
    padding:15px;
  }
  .expressage .info{
    font-size: 14px;
    padding-bottom:10px;
    border-bottom: 1px solid #F0F0F0;
    margin-bottom: 10px;
  }
  .expressage .info span{
    float: right;
  }
  .expressage .van-cell{
    padding:0;
  }
  .goods-price{
    background: #ffffff;
    overflow: hidden;
    padding:10px 15px;
    margin-top: 10px;
  }
  .goods-price .g-r-li{
    font-size: 14px;
    padding:5px 0;
    color:#646566;
  }
  .goods-price .g-r-li span{
    color:#000000;
  }
</style>



// WEBPACK FOOTER //
// src/views/payment/index.vue